export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'conflicts' as const;

export const CONFLICT_TYPES = {
  SHIFT: 'shift',
  TIME_OFF: 'timeOff',
  AVAILABILITY: 'availability',

  // Map API values to our internal representation
  fromApiValue: (value: string) => {
    // Convert snake_case to camelCase
    if (value === 'time_off') return 'timeOff';
    if (value === 'availability') return 'availability';
    // For any other values, return as-is to support unknown conflict types
    return value;
  },
} as const;
